function getUniqueNameNumber(objects: any[], length: number, order: number): number {
  return objects.find(({ name }) => name.slice(length) === order.toString())
    ? getUniqueNameNumber(objects, length, order + 1)
    : order;
}

export default getUniqueNameNumber;
